import { render, staticRenderFns } from "./DriverManage.vue?vue&type=template&id=6dbd1424&scoped=true&"
import script from "./DriverManage.vue?vue&type=script&lang=js&"
export * from "./DriverManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbd1424",
  null
  
)

export default component.exports